import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import tooltipPayloadType from '../proptypes/tooltip-payload';
import PhrasesContext from './contexts/PhrasesContext';

const CustomTooltip = ({ label, payload }) => {
  const { noData: noDataPhrase } = useContext(PhrasesContext);

  if (!label) return null;

  return (
    <div className="custom-tooltip">
      {
        payload.map(item => (
          <div key={item.dataKey} className="custom-tooltip__layer">
            <strong className="custom-tooltip__key">{`${item.name}:`}</strong>
            <strong className="custom-tooltip__value">{!item.value ? noDataPhrase : `${item.value}%`}</strong>
          </div>
        )).reverse()
      }
    </div>
  );
};

CustomTooltip.defaultProps = {
  label: null,
  payload: [],
};

CustomTooltip.propTypes = {
  label: PropTypes.string,
  payload: PropTypes.arrayOf(tooltipPayloadType),
};

export default CustomTooltip;
